import React from "react";
import NavBar from "../Component/Navs/navbar";
import Container from "@mui/material/Container";
import Blog from "../Component/Blog/Blog";
import Grid from "@mui/material/Unstable_Grid2";
import hc1 from "../pic/Hosptial-1-1024x471.webp";
import hc2 from "../pic/Hosptital-2-1024x471.webp";
import hc3 from "../pic/Hosptial-3-1024x471.webp";
import edu1 from "../pic/nekhlass.jpg";
import edu14 from "../pic/nkhls.jpg";
import edu2 from "../pic/school-2-1024x768.webp";
import edu3 from "../pic/school-3-1024x768.webp";
import edu4 from "../pic/school4.webp";
import edu5 from "../pic/school5.webp";
import edu6 from "../pic/nakhlsssssssssss.jpg";
import edu7 from "../pic/nekhlas.jpg";
import edu8 from "../pic/school8.webp";
import edu9 from "../pic/school9.webp";
import edu10 from "../pic/educ 01.jpg";
import edu11 from "../pic/Educ 02.jpg";
import edu12 from "../pic/Educ 03.jpg";
import edu13 from "../pic/educ 04.jpg";
import edu15 from "../pic/333333333333333333333333333.jpg";
import edu16 from "../pic/55555555555555555555555.jpg";
import edu17 from "../pic/666666666666666666666666666.jpg";

import social4 from "../pic/social5.webp";
import social5 from "../pic/social6.webp";
import social1 from "../pic/social1.webp";
import social2 from "../pic/social2.webp";
import social3 from "../pic/social3.webp";
import hc4 from "../pic/social4.webp";

import specialized1 from "../pic/01-edit.jpg";
import specialized2 from "../pic/02-edit.jpg";
import specialized3 from "../pic/03-edit.jpg";
import specialized4 from "../pic/04-Edit.jpg";
import specialized5 from "../pic/05-edit.JPG";
import specialized6 from "../pic/06-edit.JPG";
import specialized7 from "../pic/07-edit.JPG";
import specialized8 from "../pic/08-edit.JPG";

import sp1 from "../pic/04.jpg";
import sp2 from "../pic/01.jpg";
import sp3 from "../pic/02.jpg";
import sp4 from "../pic/03.jpg";




const SocialContributions = [
  {
    label: "Social Contribution",
    imgPath: social4,
  },
  {
    label: "Social Contribution",
    imgPath: social1,
  },

  {
    label: "Social Contribution",
    imgPath: social2,
  },
  {
    label: "Social Contribution",
    imgPath: social3,
  },
  {
    label: "Social Contribution",
    imgPath: social5,
  },
];
const HealthCare = [
  {
    label: "Health Care",
    imgPath: hc1,
  },

  {
    label: "Health Care",
    imgPath: hc2,
  },
  {
    label: "Health Care",
    imgPath: hc3,
  },
  {
    label: "Health Care",
    imgPath: hc4,
  },
];

const Education = [
  {
    label: "Education",
    imgPath: edu11,
  },
  {
    label: "Education",
    imgPath: edu12,
  },
    {
    label: "Education",
    imgPath: edu10,
  },
   {
    label: "Education",
    imgPath: edu13,
  },
  {
    label: "Education",
    imgPath: edu15,
  },
   {
    label: "Education",
    imgPath: edu16,
  },
  {
    label: "Education",
    imgPath: edu17,
  },
  
  {
    label: "Education",
    imgPath: edu14,
  },
  
  {
    label: "Education",
    imgPath: edu9,
  },
  {
    label: "Education",
    imgPath: edu1,
  },
  {
    label: "Education",
    imgPath: edu8,
  },
  {
    label: "Education",
    imgPath: edu4,
  },
  {
    label: "Education",
    imgPath: edu6,
  },
  {
    label: "Education",
    imgPath: edu5,
  },
  {
    label: "Education",
    imgPath: edu7,
  },
  {
    label: "Education",
    imgPath: edu2,
  },
  {
    label: "Education",
    imgPath: edu3,
  },
  
  
];
const Specialized  = [
  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized1,
  },
  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized2,
  },

  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized3,
  },
  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized4,
  },
    {
    label: "Specialized Youth Initiatives",
    imgPath: specialized5,
  },
  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized6,
  },

  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized7,
  },
  {
    label: "Specialized Youth Initiatives",
    imgPath: specialized8,
  },
  {
    label: "Specialized Youth Initiatives",
    imgPath: sp2,
  },
   {
    label: "Specialized Youth Initiatives",
    imgPath: sp1,
  },
  
  {
    label: "Specialized Youth Initiatives",
    imgPath: sp3,
  },
  {
    label: "Specialized Youth Initiatives",
    imgPath: sp4,
  },


];
const Social = () => {
  return (
    <>
      <NavBar />
      <Container fixed style={{ color: "#383838" }}>
        <h1 style={{ fontSize: "32px", fontWeight: "800px" }}>
          Sustainable Development & Social Responsibilities
        </h1>
        <p style={{ fontSize: "18px" }}>
          Scimitar  contributes to the sustainable development of its
          surrounding communities in three major sectors:{" "}
          <span
            style={{ fontStyle: "italic", color: "#72772", fontWeight: "bold" }}
          >
            Education, Healthcare and Decent Way of Life,
          </span>{" "}
          which is aligned with the President Directions and the government
          efforts to uplift these three sectors.
        </p>
        <p style={{ fontSize: "18px" }}>
          Scimitar also supports the local municipality in their efforts in
          dealing with road accidents, road repair, trees planting, natural
          crises, flooding, pollution reduction and medical care in Ras Gharib
          and Zaafrana.
        </p>
        <p style={{ fontSize: "18px" }}>
          Scimitar’s Contribution in Ras Gharib includes In-kind donation to
          schools, hospitals, clinics, and poor communities in close
          coordination with local authorities.
        </p>
        <p style={{ fontSize: "18px" }}>
          Scimitar supports job seekers in Ras Gharib and provides training and
          internships to university students. Many of our contractors and
          suppliers are from Ras Gharib. This is another way in which Scimitar’s
          presence supports the local Ras Gharib economy and helps it to nourish
          and grow.
        </p>
        <p style={{ fontSize: "18px" }}>
          Scimitar develops specialized youth initiatives, aimed at fostering long-term safety awareness and environmental responsibility. Through interactive educational campaigns, drawing contests and collaborative projects. These efforts equip the young generation with the tools to advocate safe practices and sustainable solutions in their communities and future workplaces
        </p>
      </Container>
      <Grid container spacing={2} sx={{ marginX: "10%" }}>
        <Grid xs={12} md={4}>
          <Blog data={HealthCare} />
        </Grid>
        <Grid xs={12} md={4}>
          <Blog data={Education} />
        </Grid>
        <Grid xs={12} md={4}>
          <Blog data={SocialContributions} />
        </Grid>
        <Grid xs={12} md={4}>
          <Blog data={Specialized} />
        </Grid>
      </Grid>
    </>
  );
};

export default Social;
